import { t } from "ember-intl";
import StatusIndicator from "glesys-controlpanel/components/status-indicator";
import Field from "glesys-controlpanel/components/entity/fields/field";

<template>
  <span
    class="grid grid-cols-2 gap-x-6 gap-y-3 px-4 pt-[11px] pb-3.5 border-t border-gray-200 sm:flex sm:flex-wrap sm:gap-x-12 sm:gap-y-4 sm:px-6 sm:pt-[13px] sm:pb-4"
    data-test-entity-fields
  >
    {{#if @status}}
      <Field @label={{t "label.status"}}>
        <StatusIndicator data-test-entity-status @status={{@status}} @size="small" @showLabel={{true}} />
      </Field>
    {{/if}}
    {{yield}}
  </span>
</template>
